<template>
  <div>
    <p class="tips">点击小方块进行预约,一个小方块代表时长15分钟,一个小时划分为4个小方块</p>
  </div>
</template>
<script>
export default {
  data() {
    return {
        
    }
  },
  props: ["timeList"],
  mounted() {
    console.log(this.timeList,'timelist')
  }
};
</script>
<style lang="less" scoped>
.tips {
  padding: 20px;
}
</style>